/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserEventTimelinePayload
 */
export interface UserEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof UserEventTimelinePayload
     */
    externalUserId: string;
    /**
     * 
     * @type {string}
     * @memberof UserEventTimelinePayload
     */
    externalUserType: string;
    /**
     * 
     * @type {string}
     * @memberof UserEventTimelinePayload
     */
    companyCountry: string;
}

/**
 * Check if a given object implements the UserEventTimelinePayload interface.
 */
export function instanceOfUserEventTimelinePayload(value: object): value is UserEventTimelinePayload {
    if (!('externalUserId' in value) || value['externalUserId'] === undefined) return false;
    if (!('externalUserType' in value) || value['externalUserType'] === undefined) return false;
    if (!('companyCountry' in value) || value['companyCountry'] === undefined) return false;
    return true;
}

export function UserEventTimelinePayloadFromJSON(json: any): UserEventTimelinePayload {
    return UserEventTimelinePayloadFromJSONTyped(json, false);
}

export function UserEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'externalUserId': json['externalUserId'],
        'externalUserType': json['externalUserType'],
        'companyCountry': json['companyCountry'],
    };
}

export function UserEventTimelinePayloadToJSON(value?: UserEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'externalUserId': value['externalUserId'],
        'externalUserType': value['externalUserType'],
        'companyCountry': value['companyCountry'],
    };
}

